<!--
 * @Author: yyl
 * @Date: 2025-06-25 10:28:46
 * @LastEditTime: 2025-07-02 09:28:11
 * @LastEditors: yyl
 * @Description: 
 * @FilePath: /bolimao/Users/bolimao/Desktop/A-类私有云的项目/下关中学/xiaguan-schools-website/src/App.vue
 * 可以输入预定的版权声明、个性签名、空行等
-->
<template>
  <div id="app" class="app">
    <div class="header">
      <div class="container">
        欢迎访问{{ basicinfo.school }}！
        <span>{{ time }}</span>
      </div>
    </div>

    <div style="background-color: #e8edf4">
      <div class="container flex items-center" style="padding: 20px 0">
        <div class="flex items-center">
          <img :src="basicinfo.logo_one" width="80px" height="80px" />
        </div>
        <div
          style="
            margin-left: 20px;
            font-size: 30px;
            color: #1e54a2;
            font-weight: bold;
          "
        >
          {{ basicinfo.school }}
        </div>
      </div>
    </div>

    <Navbar />

    <el-container class="page-component__scroll">
      <el-main style="background-color: #f4f5f7">
        <router-view />
      </el-main>
    </el-container>

    <el-footer style="height: auto; padding: 0">
      <div>
        <div class="container flex" style="padding: 20px 0; flex-wrap: wrap">
          <div
            style="
              border-left: 2px solid #1c3a97;
              padding-left: 4px;
              white-space: nowrap;
            "
          >
            快速通道：
          </div>

          <div class="flex">
            <div v-for="item in link" :key="item.url" style="padding: 0 6px">
              <a :href="item.link" target="_blank">{{ item.title }}</a>
            </div>
          </div>
        </div>
      </div>

      <div style="padding: 20px 0; background-color: #1c3a97">
        <div class="container">
          <div v-html="basicinfo.content" style="color: #fff"></div>

          <!-- <div style="text-align: center">
            <a style="color: #fff" href="https://beian.miit.gov.cn">{{
              basicinfo.record
            }}</a>
          </div> -->
        </div>
      </div>
    </el-footer>

    <div
      v-if="!isMobile && (float.length > 0 || basicinfo.float_content)"
      style="
        width: 130px;
        position: fixed;
        right: 20px;
        top: 200px;
        background: #fff;
        padding: 10px;
        border: 1px solid #90b8ad;
        border-radius: 3px;
        font-size: 12px;
      "
    >
      <div v-for="item in float" :key="item.id" style="text-align: center">
        <div>
          <el-image
            style="width: 122px; height: 122px"
            :src="item.url"
            fit="fill"
          ></el-image>
        </div>
        <div style="white-space: pre-line; padding-bottom: 6px">
          {{ item.title }}
        </div>
      </div>

      <div
        style="
          white-space: pre-line;
          border-top: 1px solid #70ad95;
          padding-top: 4px;
        "
      >
        {{ basicinfo.float_content }}
      </div>
    </div>

    <el-backtop :right="50" :bottom="50"></el-backtop>
  </div>
</template>

<script>
import dayjs from "dayjs"

import Navbar from "@/components/Navbar.vue"

import { getSchoolIntro } from "@/api/home"

import resizeMixin from "@/mixins/resize"

export default {
  name: "App",

  components: { Navbar },

  mixins: [resizeMixin],

  data() {
    return {
      schoolIntro: {},
      basicinfo: {},
      link: [],
      float: [],

      time: "",
    }
  },

  created() {
    this.loadIntro()

    this.time = dayjs().format("YYYY-MM-DD HH:mm")

    setInterval(() => {
      this.time = dayjs().format("YYYY-MM-DD HH:mm")
    }, 30000)
  },

  methods: {
    async loadIntro() {
      try {
        const res = await getSchoolIntro()

        this.schoolIntro = res
        this.basicinfo = this.schoolIntro.basicinfo || {}
        this.link = this.schoolIntro.link || []
        this.float = this.schoolIntro.float || []
        document.title = this.basicinfo.school
        this.changeFavicon(`${this.basicinfo.logo_two}`)
        localStorage.removeItem("schoolIntro")
        localStorage.setItem("schoolIntro", JSON.stringify(this.schoolIntro))
      } catch (err) {
        console.error("加载学校简介失败", err)
      }
    },

    changeFavicon(url) {
      let link = document.createElement("link")
      link.type = "image/x-icon"
      link.rel = "shortcut icon"
      link.href = url
      document.getElementsByTagName("head")[0].appendChild(link)
    },

    // 调用函数，传入新的favicon URL

    onResize() {
      this.isMobile = window.innerWidth < 768 // 当窗口宽度小于 768px 时，认为是移动端
    },
  },
}
</script>

<style scoped lang="scss">
.app {
  display: flex;
  flex-direction: column;
  height: 100vh;
  // overflow: hidden;
}

.header {
  color: #999091;
  font-size: 12px;
  line-height: 40px;
}

a {
  color: #565656;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
}
</style>
